import { ApiService } from "./api.service";
import { downloadFile } from "../_helpers/downloadFile"
import axios from "axios";
import { ToastService } from "./toast.service";

export const InventoryService = {
    fetchProductById,
    fetchProduct,
    fetchProductPresentationList,
    fetchProductByVendor,
    productGetOrCreate,
    updateProduct,
    fetchProductList,
    fetchPriceList,
    fetchProductPrice,
    createProductPrice,
    fetchProductPriceList,
    productDelete,
    fetchProductCategory,
    fetchProductCategoryList,
    bookProduct,
    updateProductPrice,
    deleteProductPrice,
    productReport,
    downloadProductReport,
    downloadInvReport1,
    downloadInvReport2,
    downloadInvReport3,
    downloadInvReport4,
    downloadInvReport5,
    downloadProductsPriceExcel,
    productClassGetOrCreate,
    productClassCreate,
    productClassEdit,
    productClassDelete,
    productClassList,
    uofmeGetOrCreate,
    uofmeGet,
    uofmeEdit,
    uofmeDelete,
    uofmeList,
    locationGetOrCreate,
    locationGet,
    locationEdit,
    locationDelete,
    locationList,
    locationCreateAssignment,
    priceMasterGetOrCreate,
    priceMasterEdit,
    priceMasterGet,
    priceMasterList,
    priceMasterDelete,
    uofmePlanGet,
    uofmePlanGetOrCreate,
    uofmePlans,
    uofmePlanEdit,
    uofmePlanDelete,
    uofmePlanDetailCreate,
    uofmePlanDetails,
    uofmePlanDetailDelete,
    reasonCategoryGetOrCreate,
    reasonCategories,
    reasonCategoryEdit,
    reasonCategoryDelete,
    reasonCreate,
    reasonsGet,
    reasonsByCategory,
    reasonDelete,
    productLotMasterGetList,
    productLotMasterGetListInquiry,
    productAssemblyCreate,
    productAssemblyEdit,
    productAssemblyDelete,
    productAssemblyList,
    productAssemblyListByLocation,
    productLocationGet,
    productLocationCreate,
    productLocationUpdate,
    productLocationDelete,
    productLocationList,
    productGetTransactionHistory,
    transactionOpenMasterCreate,
    transactionOpenMasterGet,
    transactionOpenMasterEdit,
    transactionOpenMasterDelete,
    transactionOpenMasterGetList,
    transactionOpenDetailCreate,
    transactionOpenDetailGet,
    transactionOpenDetailGetById,
    transactionOpenDetailEdit,
    transactionOpenDetailDelete,
    transactionOpenLotItemGetList,
    transactionOpenLotItemPost,
    transactionOpenLotItemDelete,
    transactionOpenLotAssign,
    postInventoryTransaction,
    downloadXSLOpenAdjustment,
    fetchProductExtraField

}

function fetchProductExtraField(productCode) {
    return ApiService.post(`inventory/product-extra-field`, { productCode })
}

function fetchProduct(product_code) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post(`/inventory/product/`, { product_code });
}

function fetchProductById(id) {
  //   /**
  //    * @returns object
  //    **/
  return ApiService.get(`/inventory/product/${id}`);
}

function fetchProductList(query, col, mod, page = 0) {
    /**
    //    * Fetch all products with limit 25
    //    *
    //    * @returns array
    //    * @throws AuthenticationError
    //    **/
    return ApiService.get(`/inventory/product-list?q=${query}&col=${col}&mod=${mod}&page=${page}`);
}

function fetchProductPresentationList(short_name, brand) {
    return ApiService.post('/inventory/product/getPresentations', { short_name, brand })
}

/**
    * @returns object saved with default values
    **/
function productGetOrCreate(data) {
     return ApiService.post('/inventory/product/r/c',data)
}

/**
* @returns object saved
**/
function updateProduct (data){
    return ApiService.put('/inventory/product/',data)
}




/**
* @returns object saved
**/
function fetchPriceList(page) {
    /**
    //    * Fetch all price with limit 25
    //    *
    //    * @returns array
    //    **/
    if (!page) page = 0;
    return ApiService.get(`/inventory/product/price-list?page=${page}`)
}
function fetchProductPrice(productCode, priceCode, currencyCode, uofmeCode) {
    return ApiService.post(`/inventory/product/getPrice`, {productCode, priceCode, currencyCode, uofmeCode})
}
function createProductPrice(data){
    /**
    * @returns object saved
    **/
   return ApiService.post('/inventory/product/price', data);
}
function updateProductPrice(data){
    return ApiService.put('/inventory/product/price', data)
}
function deleteProductPrice(id){
    /**
    * @returns object saved
    **/
   return ApiService.delete(`/inventory/product/price/${id}`);
}


function fetchProductPriceList(product_code, page) {
    /**
    //    * Fetch all price with limit 25
    //    *
    //    * @returns array
    //    **/
    //if (!offset) offset = 0
    if (!page) page = 0;
    return ApiService.get(`/inventory/product/price/list?product_code=${product_code}&page=${page}`)
}

function productDelete(id) {
    /**
    * @returns object saved
    **/
   return ApiService.delete(`/inventory/product/${id}`);
}

function fetchProductCategory(category_code) {
    /**
    * @returns object saved
    **/
   return ApiService.get(`/inventory/category?category_code=${category_code}`);
}

function fetchProductCategoryList(page) {
    /**
    * @returns array of top 25
    **/
   return ApiService.get(`/inventory/category-list?page=${page}`);
}

function productClassGetOrCreate(class_code){
    return ApiService.post(`/inventory/class-master/r/c`, { class_code })
}

function productClassEdit(data){
    return ApiService.put(`/inventory/class-master/`, data)
}

function productClassCreate(){
    return ApiService.post(`/inventory/class-master/`)
}

function productClassList(page){
    return ApiService.get(`/inventory/class-master-list?page=${page}`)
}

function productClassDelete(id) {
    return ApiService.delete(`/inventory/class-master/${id}`)
}

function productAssemblyCreate(data){
    return ApiService.post(`/inventory/product-assembly/`, data)
}

function productAssemblyEdit(data){
    return ApiService.put(`/inventory/product-assembly/`, data)
}

function productAssemblyList(master_code, page){
    return ApiService.post(`/inventory/product-assembly/getAssemblies`, { master_code, page })
}

function productAssemblyListByLocation(master_code, location_code){
  return ApiService.post(`/inventory/product-assembly/getAssembliesByLocation`, { master_code, location_code })
}

function productAssemblyDelete(id) {
    return ApiService.delete(`/inventory/product-assembly/${id}`)
}

function productLocationCreate(data){
    return ApiService.post(`/inventory/product-location/`, data)
}

function productLocationUpdate(data) {
    return ApiService.put(`/inventory/product-location/`, data)
}

function productLocationList(product_code,include_totals = false, page = 0){
    return ApiService.post(`/inventory/product-location/getList`, {
      product_code,
      include_totals,
      page
     })
}

function productLocationGet(product_code, location_code){
    return ApiService.get(`/inventory/product-location?product_code=${product_code}&location_code=${location_code}`)
}

function productLocationDelete(id) {
    return ApiService.delete(`/inventory/product-location/${id}`)
}

function uofmePlanGet(uofmePlanCode){
    return ApiService.get(`/inventory/setup/unit-of-measure-plan?uofmePlanCode=${uofmePlanCode}`)
}

function uofmePlanGetOrCreate(uofmePlanCode){
    return ApiService.post(`/inventory/setup/unit-of-measure-plan/r/c`, { uofmePlanCode })
}

function uofmePlans(page = 0, limit = 9999){
    return ApiService.get(`/inventory/setup/unit-of-measure-plans?page=${page}&limit=${limit}`)
}

function uofmePlanEdit(data){
    return ApiService.put(`/inventory/setup/unit-of-measure-plan/`, data)
}

function uofmePlanDelete(id) {
    return ApiService.delete(`/inventory/setup/unit-of-measure-plan/${id}`)
}

function uofmePlanDetailCreate(data){
    return ApiService.post(`/inventory/setup/unit-of-measure-plan/detail`, data)
}

function uofmePlanDetails(uofmePlanCode){
    return ApiService.get(`/inventory/setup/unit-of-measure-plan/details?uofmePlanCode=${uofmePlanCode}`)
}

function uofmePlanDetailDelete(id){
    return ApiService.delete(`/inventory/setup/unit-of-measure-plan/detail/${id}`)
}

//

function reasonCategoryGet(categoryCode){
    return ApiService.get(`/inventory/setup/reason-category?categoryCode=${categoryCode}`)
}

function reasonCategoryGetOrCreate(categoryCode, documentType){
    return ApiService.post(`/inventory/setup/reason-category/`, { categoryCode, documentType })
}

function reasonCategories( documentType, page = 0, limit = 9999){
    return ApiService.get(`/inventory/setup/reason-categories?documentType=${documentType}&page=${page}&limit=${limit}`)
}

function reasonCategoryEdit(data){
    return ApiService.put(`/inventory/setup/reason-category/`, data)
}

function reasonCategoryDelete(id) {
    return ApiService.delete(`/inventory/setup/reason-category/${id}`)
}

function reasonsGet(query, col, page, limit, documentType = 0){
    return ApiService.get(`/inventory/setup/reasons?documentType=${documentType}&query=${query}&col=${col}&page=${page}&limit=${limit}`)
}
function reasonsByCategory(categoryCode, documentType){
    return ApiService.get(`/inventory/setup/reasons-by-category?categoryCode=${categoryCode}&documentType=${documentType}`)
}
function reasonCreate(data){
    return ApiService.post(`/inventory/setup/reason`, data)
}

function reasonDelete(id){
    return ApiService.delete(`/inventory/setup/reason/${id}`)
}

function productLotMasterGetList(productCode, locationCode) {
    return ApiService.post(`/inventory/product/getAvailableLots/`, { productCode, locationCode })
}
function productLotMasterGetListInquiry(productCode, locationCode) {
    return ApiService.post(`/inventory/product/getOpenLots/`, { productCode, locationCode })
}
function locationGetOrCreate(location_code){
    return ApiService.post(`/inventory/location/r/c`, { location_code })
}

function locationEdit(data){
    return ApiService.put(`/inventory/location/`, data)
}

function locationGet(location_code){
    return ApiService.get(`/inventory/location/${location_code}`)
}

function locationList(query, page){
    return ApiService.get(`/inventory/location-list?page=${page}`)
}

function locationDelete(id) {
    return ApiService.delete(`/inventory/location/${id}`)
}

function locationCreateAssignment(id, classCode) {
    return ApiService.post(`/inventory/location/assignment/`, { id, classCode })
}

function priceMasterGetOrCreate(price_code){
    return ApiService.post(`/inventory/price/r/c`, { price_code })
}

function priceMasterEdit(data){
    return ApiService.put(`/inventory/price/`, data)
}

function priceMasterGet(price_code){
    return ApiService.get(`/inventory/price/${price_code}`)
}

function priceMasterList(query, page){
    return ApiService.get(`/inventory/price-list?query=${query}&page=${page}`)
}

function priceMasterDelete(id) {
    return ApiService.delete(`/inventory/price/${id}`)
}

function uofmeGetOrCreate(uofme_code){
    return ApiService.post(`/inventory/unit-of-measure/r/c`, { uofme_code })
}

function uofmeEdit(data){
    return ApiService.put(`/inventory/unit-of-measure/`, data)
}

function uofmeGet(uofme_code){
    return ApiService.get(`/inventory/unit-of-measure/${uofme_code}`)
}

function uofmeList(query, page){
    return ApiService.get(`/inventory/unit-of-measure-list?page=${page}`)
}

function uofmeDelete(class_code) {
    return ApiService.delete(`/inventory/unit-of-measure/${class_code}`)
}


function fetchProductByVendor(productCode, vendorCode) {
    /**
    * @returns object
    **/
   return ApiService.get(`/inventory/product/vendor/${productCode}/${vendorCode}`);
}

function productGetTransactionHistory(product_code, location_code, page, limit, balance ) {
    return ApiService.post(`/inventory/getHistoryTransaction?limit=${limit}&page=${page}`, { product_code, location_code, balance });
}

function bookProduct () {
    /**
    * @returns object
    **/
   return ApiService.post('/inventory/product/create/');
}

/** Reports */
function productReport(page, limit, location_code) {
    /**
    * @returns array of top 50
    **/
   return ApiService.post(`/inventory/report/product-list?page=${page}&limit=${limit}`, { location_code });
}

function downloadProductReport() {
    axios({
        url: "/inventory/report/to-xcl/product-list",
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => downloadFile(response, "product.xlsx"));

}

function downloadInvReport1(location_code) {
  axios({
    url: `/inventory/report/to-xcl/1?location_code=${location_code}`,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => downloadFile(response, "Inventario x Almacén.xlsx"));
}

function downloadInvReport2(product_code, location_code, lot_number) {
  axios({
    url: `/inventory/report/to-xcl/2?product_code=${product_code}&location_code=${location_code}&lot_number=${lot_number}`,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => downloadFile(response, "Inventario x Lotes.xlsx"));
}

function downloadInvReport3(location_code) {
  axios({
    url: `/inventory/report/to-xcl/3?location_code=${location_code}`,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => downloadFile(response, "Productos x Almacén primario.xlsx"));
}
function downloadInvReport4(location_code, at_date) {
  axios({
    url: `/inventory/report/to-xcl/4?location_code=${location_code}&at_date=${at_date}`,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => downloadFile(response, `Inventario ${location_code} al ${at_date}.xlsx`));
}
function downloadInvReport5(date_from, date_to) {
  axios({
    url: `/inventory/report/to-xcl/5?date_from=${date_from}&date_to=${date_to}`,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => downloadFile(response, `Ajustes de Inventario ${date_from} al ${date_to}.xlsx`));
}
function downloadProductsPriceExcel() {
    axios({
      url: `/inventory/report/productsPrice/downloadExcel`,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => downloadFile(response, "Precios-de-lista.xlsx"));
  }
function transactionOpenMasterCreate(tran_type) {
    return ApiService.post(`/inventory/transaction/open/master/`,{tran_type});
}
function transactionOpenMasterGet(tran_type,tran_number) {
    return ApiService.get(`/inventory/transaction/open/master/${tran_type}/${tran_number}`);
}
function transactionOpenMasterEdit(data) {
    return ApiService.put(`/inventory/transaction/open/master/`, data);
}
function transactionOpenMasterDelete(id) {
    return ApiService.delete(`/inventory/transaction/open/master/${id}`);
}
function transactionOpenMasterGetList(tran_type) {
    return ApiService.get(`/inventory/transaction/open/master/${tran_type}`);
}


function transactionOpenDetailCreate(id, productCode) {
    return ApiService.post(`/inventory/transaction/open/item`, {id, productCode});
}
function transactionOpenDetailGet(tran_type, tran_number, page, limit) {
    return ApiService.get(`/inventory/transaction/open/item/${tran_type}/${tran_number}?page=${page}&limit=${limit}`);
}
function transactionOpenDetailGetById(id) {
    return ApiService.get(`/inventory/transaction/open/item-by-id/${id}`);
}
function transactionOpenDetailEdit(data) {
    return ApiService.put(`/inventory/transaction/open/item/`, data);
}
function transactionOpenDetailDelete(id) {
    return ApiService.delete(`/inventory/transaction/open/item/${id}`);
}

function transactionOpenLotItemGetList(tran_type, tran_number, line_seq) {
    return ApiService.get(`/inventory/transaction/open/item/lot/${tran_type}/${tran_number}/${line_seq}`);
}
function transactionOpenLotItemPost({id, lot_number, expiration_date, lot_qty, bin_number}) {
    return ApiService.post(`/inventory/transaction/open/item/lot/`, {id, lot_number, expiration_date, lot_qty, bin_number});
}
function transactionOpenLotItemDelete(id) {
    return ApiService.delete(`/inventory/transaction/open/item/lot/${id}`);
}
function transactionOpenLotAssign(id, id_lot) {

    return ApiService.post(`/inventory/transaction/open/item/lot-assignment/`, {id, ...id_lot})
}
function postInventoryTransaction(id) {
    return ApiService.post(`/inventory/transaction/posting/`, {id});
}
function downloadXSLOpenAdjustment(tranNumber) {
    return axios({
        url:'/inventory/report/open-adjustment/',
        data: { tranNumber},
        method: 'POST',
        responseType: 'blob'
    })
    .then(response => downloadFile(response, `${tranNumber}.xlsx`))
}



// const InventoryService = {
//   /**
//    * Fetch all products with limit 25
//    *
//    * @returns array
//    * @throws AuthenticationError
//    **/
//   fetchProductList: function(params) {
//       return ApiService.get('/inventory/product-list');
//   },
//   /**
//    * @returns object
//    **/
//   fetchProduct: async function(product_code) {
//       return ApiService.get('/inventory/product/'+product_code);
//   },
//   /**
//    * @returns object saved
//    **/
//   updateProduct: function(data){
//       return ApiService.put('/inventory/product/',data)
//   },
//   /**
//    * @returns object saved with default values
//    **/
//   createProduct: function(data){
//     return ApiService.post('/inventory/product/',data)
//   }

// };

// export default InventoryService;



// WEBPACK FOOTER //
// ./src/services/inventory.service.js